import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'calintent-auth',
    flowType: 'pkce'
  }
})

// Auth utilities
export const auth = {
  signInWithGoogle: () => {
    return supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`
      }
    })
  },
  
  signOut: () => {
    return supabase.auth.signOut({ scope: 'local' })
  },
  
  getSession: () => {
    return supabase.auth.getSession()
  },
  
  getUser: () => {
    return supabase.auth.getUser()
  }
}

// Database utilities
export const db = {
  // Add database operation utilities here as needed
  
  // Example utility for getting user profile
  getUserProfile: async (userId: string) => {
    return supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single()
  },
  
  // Example utility for updating user profile
  updateUserProfile: async (userId: string, updates: Record<string, unknown>) => {
    return supabase
      .from('profiles')
      .update(updates)
      .eq('id', userId)
  }
}

// Realtime utilities
export const realtime = {
  // Subscribe to table changes
  subscribeToTable: (table: string, callback: (payload: unknown) => void) => {
    return supabase
      .channel(`public:${table}`)
      .on('postgres_changes', 
        { event: '*', schema: 'public', table }, 
        callback
      )
      .subscribe()
  },
  
  // Subscribe to user-specific changes (requires RLS)
  subscribeToUserData: (userId: string, table: string, callback: (payload: unknown) => void) => {
    return supabase
      .channel(`user-${userId}:${table}`)
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table,
          filter: `user_id=eq.${userId}`
        }, 
        callback
      )
      .subscribe()
  }
}
